<vex-page-layout>

  <vex-page-layout-header class="flex flex-col items-start justify-center">
    <div class="w-full flex flex-col sm:flex-row justify-between">
      <div>
        <div class="flex items-center gap-1">
          <h1 class="title mt-0 mb-1">{{ 'nav.fileManager' | translate }}</h1>
          <app-wiki-help-link path="/managing-files"></app-wiki-help-link>
        </div>
        <vex-breadcrumbs [crumbs]="['nav.fileManager' | translate]"></vex-breadcrumbs>
      </div>
    </div>
  </vex-page-layout-header>

  <vex-page-layout-content class="mt-6">
    <div class="file-manager full-size-file-manager">
      <div class="card overflow-auto">
        <div class="file-manager--folders">
          <div class="folders-content">
            <div class="add-folder">
              <form (submit)="createFolder()" [formGroup]="createFolderForm">
                <div class="flex flex-col sm:flex-row">
                  <mat-form-field class="flex-auto">
                    <mat-label>{{ 'fileManager.newFolderName' | translate }}</mat-label>
                    <input formControlName="name" matInput>
                    <button mat-icon-button matIconSuffix [pTooltip]="'fileManager.addFolder' | translate" tooltipPosition="bottom">
                      <mat-icon svgIcon="mat:add"></mat-icon>
                    </button>
                  </mat-form-field>
                </div>
              </form>
            </div>
            <div class="folders-list"
                 [class.moving-action]="movedFileId"
            >
              <div class="list mat-elevation-z1"
                   cdkDropList
                   [cdkDropListData]="folders"
                   (cdkDropListDropped)="sortFolders($event)">
                <div *ngFor="let folder of folders"
                     class="folder-item"
                     cdkDrag
                     cdkDragLockAxis="y"
                     [class.selected]="folder === selectedFolder"
                     [class.edited]="folder.id === editedFolderId">
                  <form *ngIf="folder.id === editedFolderId" (submit)="renameFolder()" [formGroup]="renameFolderForm">
                    <div class="flex flex-col sm:flex-row">
                      <mat-form-field class="flex-auto">
                        <mat-label>{{ 'fileManager.newFolderName' | translate }}</mat-label>
                        <input formControlName="name" matInput>
                        <button type="submit" mat-icon-button matIconSuffix [pTooltip]="'fileManager.saveChanges' | translate" tooltipPosition="bottom">
                          <mat-icon svgIcon="mat:check"></mat-icon>
                        </button>
                        <button type="button" (click)="closeFolderEditForm()" mat-icon-button matIconSuffix [pTooltip]="'fileManager.cancelEdit' | translate" tooltipPosition="bottom">
                          <mat-icon svgIcon="mat:close"></mat-icon>
                        </button>
                      </mat-form-field>
                    </div>
                  </form>
                  <h3 (click)="selectFolder(folder)">
                    <span *ngIf="folder.id !== editedFolderId">{{ folder.name }}</span>
                  </h3>
                  <button *ngIf="movedFileId" mat-icon-button matIconSuffix type="button"
                          (click)="moveFile(folder)" [pTooltip]="'fileManager.moveToFolder' | translate" tooltipPosition="bottom">
                    <mat-icon svgIcon="mat:drive_file_move_rtl"></mat-icon>
                  </button>
                  <button *ngIf="folder.id !== editedFolderId && !movedFileId" mat-icon-button matIconSuffix
                          type="button"
                          (click)="openFolderRenameForm(folder)" [pTooltip]="'fileManager.edit' | translate" tooltipPosition="bottom">
                    <mat-icon svgIcon="mat:edit"></mat-icon>
                  </button>
                  <button *ngIf="folder.id !== editedFolderId && !movedFileId" mat-icon-button matIconSuffix
                          type="button"
                          (click)="deleteFolder(folder)" [pTooltip]="'common.delete' | translate" tooltipPosition="bottom">
                    <mat-icon svgIcon="mat:delete"></mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card p-2 overflow-auto">
        <div class="file-manager--files--wrapper">
          <div class="file-manager--files">
            <div class="media-manager-files--top">
              <mat-progress-bar *ngIf="isLoading" mode="indeterminate" color="primary"></mat-progress-bar>
              <div id="upload-files" class="mb-2" [class.hide-upload]="!selectedFolder"></div>
            </div>

            <div class="files-list"
                 [class.moving-action]="movedFileId"
            >
              <div class="file-item" *ngFor="let file of files"
                   [class.moved]="file.id === movedFileId"
              >
                <label>
                  <input (change)="selectFile($event, file)" [type]="getInputType()" name="selectedImage">
                  <div class="file-preview" [class.has-thumbnail]="file.thumbnail"
                       [ngStyle]="getFilePreviewStyles(file)">
                    <div class="file-preview-buttons">
                      <button [cdkCopyToClipboard]="getFileUrl(file)" mat-mini-fab color="accent" [pTooltip]="'fileManager.copyLink' | translate" tooltipPosition="bottom">
                        <mat-icon svgIcon="mat:link"></mat-icon>
                      </button>
                      <button [cdkCopyToClipboard]="getFileDownloadLink(file)" mat-mini-fab color="accent" [pTooltip]="'fileManager.download' | translate" tooltipPosition="bottom">
                        <mat-icon svgIcon="mat:download"></mat-icon>
                      </button>
                      <button (click)="openFileMoveForm(file)" mat-mini-fab color="accent" [pTooltip]="'fileManager.moveFile' | translate" tooltipPosition="bottom">
                        <mat-icon svgIcon="mat:drive_file_move"></mat-icon>
                      </button>
                      <button (click)="deleteFile(file)" mat-mini-fab color="accent" [pTooltip]="'common.delete' | translate" tooltipPosition="bottom">
                        <mat-icon svgIcon="mat:delete"></mat-icon>
                      </button>
                    </div>
                    <span (click)="rename(file)" class="file-name" [pTooltip]="'fileManager.rename' | translate" tooltipPosition="bottom">{{ file.label }}</span>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </vex-page-layout-content>

</vex-page-layout>
